<template>
  <component
    :is="fieldComponent"
    :label="field.label"
    :placeholder="field.placeholder"
    :is-required="field.required"
    :is-disabled="field.disabled || field.readonly"
    :value="currentValue"
    :options="field.options"
    :mask="field.mask"
    :config="field.config || {}"
    :helpText="field.help_text"
    :label-link-text="field.label_link_text"
    :label-link-url="field.label_link_url"
    @input="handleInput"
  />
</template>

<script>
import { computed } from 'vue';
import { getComponentForField } from '@/utils/fieldMapper';

export default {
  name: 'DynamicField',
  props: {
    field: {
      type: Object,
      required: true
    },
    modelValue: {
      default: null
    },
    value: {
      default: null
    },
    submitted: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'update:modelValue'],
  setup(props, { emit }) {
    const fieldComponent = computed(() => getComponentForField(props.field));

    const currentValue = computed(() => props.modelValue ?? props.value);

    const handleInput = (value) => {
      emit('input', value);
      emit('update:modelValue', value);
    };

    return {
      fieldComponent,
      currentValue,
      handleInput
    };
  }
};
</script>
